<template>
  <v-container>
    <v-tabs>
        <v-tab>User Admin</v-tab>
        <v-tab-item>
          <UserList />
        </v-tab-item>
        <!--
          Machine tokens are the credential a county workstation uses for the
          County Toolkit's Push to Cloud. They are their own records - no user
          account behind them - so they get their own tab rather than hanging
          off a row in the list above.
        -->
        <v-tab>Machine Tokens</v-tab>
        <v-tab-item>
          <MachineTokensList />
        </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>

import UserList from '@/components/UserAdministration/UsersList.vue';
import MachineTokensList from '@/components/UserAdministration/MachineTokensList.vue';

export default {
  name: 'Deposits',
  components: {
    UserList,
    MachineTokensList,
  },
  created() {
    this.$store.dispatch('UserAdministration/loadUsers');
    this.$store.dispatch('UserAdministration/userEnums');
  },
};
</script>
